/*
---
covers:
  - frontend/src/pages/empresa/organizacion/business-profile.tsx
  - frontend/src/pages/empresa/organizacion/cifras-empresa.tsx
  - frontend/src/components/cifra-modal.tsx
  - frontend/src/components/ciiu-risk-picker.tsx
  - frontend/src/components/perfil/sedes-section.tsx
  - frontend/src/components/perfil/sede-detail-dialog.tsx
  - frontend/src/components/photo-upload-field.tsx
  - backend/app/empresa/organizacion/routers/businesses.py
  - backend/app/common/referencias/core/risk.py
revisado: 2026-10-01
---
*/
import type {ManualSeccion} from '../types'

export const seccion: ManualSeccion = {
  id: 'perfil-de-empresa',
  titulo: 'Perfil de empresa',
  resumen:
    'Los datos base de tu empresa — CIIU, clase de riesgo, sedes y logo — de donde Kairos deriva el capítulo de la 0312 que te aplica y la tarifa ARL de tu exposición.',
  enCorto: [
    'Los datos legales de tu empresa.',
    'Fijas CIIU, clase de riesgo, ARL y sedes.',
    'De acá sale tu capítulo de la 0312.',
    'Las cifras de gestión viven en «Cifras».',
  ],
  replayId: 'perfil-de-empresa',
  operaciones: [
    {
      id: 'editar-datos-basicos',
      titulo: 'Editar los datos básicos de tu empresa',
      como: 'En «Empresa → Perfil de empresa», pestaña «Datos», usa el botón «Editar» junto al título para abrir el formulario: nombre, representante legal y ARL.',
      porQueImporta:
        'Estos datos identifican a tu empresa ante Kairos y aparecen en los artefactos que genera (matrices, expediente anual); mantenerlos al día evita inconsistencias en lo que exportas.',
    },
    {
      id: 'ciiu-y-riesgo',
      titulo: 'Cambiar el CIIU y elegir la clase de riesgo',
      como: 'Dentro del mismo formulario de edición, el campo «CIIU» abre un buscador (escribe parte del nombre de la actividad o el código); al elegir uno, Kairos muestra las clases de riesgo del Decreto 768 que aplican para que elijas la tuya.',
      porQueImporta:
        'El CIIU y la clase de riesgo determinan el capítulo de la Resolución 0312/2019 que te exige (7, 21 o 60 ítems según tu tamaño y riesgo) y la tarifa mínima de tu ARL — es la base de tu exposición legal completa.',
    },
    {
      id: 'agregar-sede',
      titulo: 'Agregar una sede',
      como: 'En la pestaña «Sedes» del perfil, el botón «Nueva sede» abre un formulario con dirección, municipio, teléfono y número de trabajadores.',
      porQueImporta:
        'Las sedes que registras aparecen en el organigrama y son el marco de referencia para las entrevistas y matrices por lugar de trabajo — sin sedes, esas vistas no tienen dónde ubicar a las personas.',
    },
    {
      id: 'fijar-una-cifra',
      titulo: 'Fijar las cifras que decide tu empresa',
      como: 'En «Empresa → Cifras de su empresa» están juntas todas las cifras que la norma no fija: el aviso de vencimiento, los plazos de la solicitud a la IPS, el plazo del examen por cambio de ocupación, la periodicidad del periódico, el reentrenamiento de alturas y qué rojos impiden entrar. Cada fila dice si el valor lo propuso Kairos o lo fijó tu empresa; el botón «Fijar» abre el formulario. Más abajo, «Vigencias del SVE por cargo» deja acortar el periódico de un cargo: antes de confirmar te muestra a cuántos exámenes les mueve el vencimiento y a cuántos los dejaría vencidos hoy. (Próximamente vas a poder fijar una cifra también desde la fila que la pida, sin salir de donde estés.)',
      porQueImporta:
        'Kairos nunca finge que tu empresa decidió algo que no decidió: mientras nadie fije una cifra, el valor sale marcado como propuesta suya, o «sin definir» cuando no tiene un número verificado que ofrecer. Fijarla deja tu nombre y la fecha, y ese texto es el que sale después en cada aviso — que es lo que un auditor te va a preguntar. Fijar una cifra es un acto de firma: lo hace el dueño o el responsable del SG-SST, nunca Kairos ni un administrador de la plataforma.',
    },
    {
      id: 'subir-logo',
      titulo: 'Subir el logo de tu empresa',
      como: 'En la pestaña «Datos», la sección «Logo» tiene un botón para subir una imagen (o reemplazarla si ya tienes una).',
      porQueImporta:
        'El logo se estampa en el encabezado de las exportaciones oficiales (como la matriz de riesgos/IPEVR) — sin él, esos documentos salen sin la identidad de tu empresa.',
    },
  ],
}
